import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, FormArray, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { APITemplateService } from '../../_services/template/API-template';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptEntityComponent } from '../../../../_helpers/Modals/prompt-entity/modal.prompt-entity';
import { varPattern } from './varPattern';


const now = new Date();
const currentdate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

@Component({
  selector: 'app-templatecontentmodify',
  templateUrl: './templatecontentmodify.component.html',
  styleUrls: ['./templatecontentmodify.component.css']
})

export class TemplatecontentmodifyComponent implements OnInit {

  @Input("data") template: any;
  contentmodifyForm: FormGroup;
  submitted = false;
  tempid: any;
  templateID: number;
  reasonslist: any = [];
  entityid: any;
  tempContent: any;
  tempCreator: any;
  tempGStatus: any;
  tempBlaclistedBy: any;
  tempReason: any;
  tempOtherReason: any;
  tempHeader: any;
  tempCreatedtimestamp: any;
  displayDetails: boolean = false;
  temptname: any;
  tempConsentid: any;
  tempStatus: any;
  tempUpdatedtimestamp: any;
  disableAction = false;
  //blrsnlist: any;
 // ublrsnlist: any;
  TemplateID: any;
  blReason: any;
  customReason: any;
  change_content: any;
  desc_template: any;
  ublcustom_reason: any;
 // no_variables:Number = 0;
 no_variables: number = 0;
  displayInformation = "false";
  //displayCustomField = 'false';
  displayInfo = "false";
  Approver_EntityID: any;
  public modalRef: BsModalRef;
  selectublitem: string;
  constructor(private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private modalService: BsModalService,
    private _route: ActivatedRoute,
    private cst: APITemplateService,) {
    this._route.params.subscribe((params) => {
    });
  }
  get f() { return this.contentmodifyForm.controls; }

  ngOnInit() {
    this.contentmodifyForm = this.fb.group({
      // Modulename:[''],
      
      templateID: ['', [Validators.required,Validators.pattern("^[0-9]*$")]],
    
      change_content: [''],
      //change_content: ['', [Validators.required, Validators.maxLength(150), Validators.minLength(10)]],
       //template_content: ['', [Validators.maxLength(750), Validators.minLength(5)]],
      // template_content: [''],
       desc_template: [''],
       justification: [''],
    },
    {
      validator: varPattern('change_content', 'no_variables')
    });
    
    
  }//end of oninit
  displayFields() {
   // Content_Modification_Request
    this.displayDetails = true;
  }
 
  changeStatus() {
    var templateID, template_content, desc_template,justification, data
    this.Approver_EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    templateID = this.contentmodifyForm.get('templateID').value
   // reason = this.contentmodifyForm.get('blreasons').value
   template_content = this.contentmodifyForm.get('change_content').value
   desc_template= this.contentmodifyForm.get('desc_template').value
   justification = this.contentmodifyForm.get('justification').value

   //let no_variables1 = this.no_variables.toString();
   console.log("---------in submit---------------------", this.no_variables)

   if (this.no_variables > 2) {  
     this.contentmodifyForm.controls['justification'].clearValidators()
     this.contentmodifyForm.controls['justification'].setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(100)])
     this.contentmodifyForm.controls['justification'].updateValueAndValidity()
     console.log(this.contentmodifyForm.controls["justification"])

   }
   else { 
     this.contentmodifyForm.controls['justification'].clearValidators()
     this.contentmodifyForm.controls['justification'].setValidators(Validators.nullValidator);
     this.contentmodifyForm.controls['justification'].updateValueAndValidity()
     console.log(this.contentmodifyForm.controls["justification"])
   }

   if (this.contentmodifyForm.controls["justification"].invalid) {
     this.$modal.errorModal({
       title: 'Template Modification',
       msg: 'Please enter Variable Justification'
     });
     return;
   }

    data = {
      tempId:templateID,
      newContent:template_content,
      remarks:desc_template,
      newNoOfVar:this.no_variables,
      justification:justification

      
    }

    
    this.cst.contenttemplatechange(data)
      .subscribe(r => {
       
        if (r.status == true) {
          this.displayDetails = false
          this.$modal.successModal({
            title: 'Template Content Modification',
            msg: r.message
          })
          this.submitted = true;
          this.disableAction = true
         
        }
        else {

          this.$modal.errorModal({
            title: 'Template Content Modification',
            msg: r.message
          })
         
        }

      })

  }
  displayVars(event){
    console.log("event value",event.target.value)
    console.log("event",event)
    this.no_variables = (event.target.value.match(/{#var#}/gi) || []).length
    
    console.log("no_variables",this.no_variables)
    
    if (this.no_variables > 2) {
      console.log("----------no_variables-----------", this.no_variables)
      this.contentmodifyForm.controls['justification'].clearValidators()
      this.contentmodifyForm.controls['justification'].setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(100)])
      this.contentmodifyForm.controls['justification'].updateValueAndValidity()
    }
    else {
      this.contentmodifyForm.controls['justification'].clearValidators()
      this.contentmodifyForm.controls['justification'].updateValueAndValidity()
    }
      }

  onChangeContent(event) {
    console.log("----------event-------------", event, this.tempGStatus)
   
      this.displayDetails = true
      this.contentmodifyForm.controls['change_content'].setValidators([Validators.required,Validators.maxLength(4590), Validators.minLength(5)])
      this.contentmodifyForm.controls['change_content'].updateValueAndValidity();
      this.contentmodifyForm.controls['desc_template'].setValidators([Validators.required,Validators.minLength(5), Validators.maxLength(500)])
      this.contentmodifyForm.controls['desc_template'].updateValueAndValidity();
   
  }
  

getInfo(){
  var templateID, data
   templateID = this.contentmodifyForm.get('templateID').value
   this.Approver_EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);

      data = {
        templateID: templateID,
        entityID: this.Approver_EntityID //Added
      }

      this.cst.getTemplateInfoForPE(data)
        .subscribe(r => {
          console.log("---------------", r.status)
          if (r.status == "200") {            
          this.displayInfo = 'true'
          this.tempid = r.message.Template_ID
          this.entityid = r.message.Entity_ID
          this.tempContent = r.message.Template_Content
          //this.tempContent = r.message.Content
          this.tempCreator =r.message.Creator
          this.tempGStatus = r.message.Global_Status
          this.tempBlaclistedBy =r.message.Blaclisted_By
          //this.tempReason = r.message.Reason
          this.tempOtherReason = r.message.Other_Reason
          this.tempHeader = r.message.Header
          this.tempCreatedtimestamp = r.message.Created_Time_UTC
          this.tempConsentid = r.message.Consent_Template_ID
          this.temptname = r.message.Template_Name
          this.tempStatus = r.message.Status
          this.tempUpdatedtimestamp = r.message.Updated_Time_UTC
          console.log(r.message.Template_ID, r.message.Entity_ID)
          
          this.submitted = true;
          this.disableAction = false
          //this.reasonslist = r.message.Global_Status == 'A' ? this.blreasonslist : this.ublreasonslist
          if(r.message.Content_Modification_Request == "M"){

            this.displayDetails = false
            this.disableAction = true
            this.$modal.errorModal({
              title: 'Template Content Modify',
              msg: "Template has been already sent for modification!"
            })
          }
          
          
                    }
          else {

            this.$modal.errorModal({
              title: 'Template Content Modify',
              msg: r.message
            })
          }

        })
}
// previewinfo() {
//   console.log("called")
//   let name = "Guidelines "
//   let contentinfo = "Please use the variable as shown below and use \\n for new line  :-  i. Transfer your outstanding Credit and debt to personal loan with interest rate as low as {#var#} ii. Dear Customer, your order number {#var#} has been dispatched. TnC apply. "
//   this.$modal.promptModal({
//     title: name,
//     msg: contentinfo
//   });
// }

  //for Form submission
  onSubmit() {
    

    
    this.displayDetails = false
   // this.displayCustomField = 'false'
    if (this.contentmodifyForm.invalid) {

      console.log("Invalid form: ", this.contentmodifyForm);
      return;
    }
    else {
       this.getInfo() ;    

    }
  }
}